export const CUSTOMERS_INDEX_TOUR = {
  id: "customers_index",
  steps: [
    {
      element: '[data-tour="customers-create"]',
      popover: {
        title: "Novo cliente",
        description:
          "Cadastre um cliente para depois vincular uma assinatura a ele.",
        side: "bottom",
      },
    },
    {
      element: '[data-tour="customers-list"]',
      popover: {
        title: "Seus clientes",
        description:
          "Acompanhe plano, status, health score e gateway de cada cliente. Clique em \"Ver\" para abrir os detalhes.",
        side: "top",
      },
    },
  ],
};
